import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IxellAPIService, IBillingDetailV1, IBillingV1, IAdresseV1, ProductType, IProductV1, PaymentInfo } from 'src/app/tools/api.service';
import { HeaderService } from 'src/app/tools/header.service';
import { PaymentService } from 'src/app/tools/payment.service';
import { ErrorService } from 'src/app/tools/error.service';
import { Product } from 'src/app/models/product';
import { bankInfo } from 'src/app/models/bankInfo';
import { StorageService } from 'src/app/tools/storage.service';
import { Language } from 'src/app/entities/Language';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { Constants } from 'src/app/entities/Constants';
import { MatStepper } from '@angular/material/stepper';

@Component({
    selector: 'laca_panier',
    templateUrl: './panier.component.html',
    styleUrls: ['./panier.component.scss']
})
export class PanierComponent implements OnInit, OnDestroy {
    @ViewChild('stepper') stepper: MatStepper;
    showAddress: boolean = false;
    countries: any = Constants.countries;
    idboutique: string = '16533760';//'12345678';
    tva: number = 0;
    isTva: boolean = false;
    ctxMode: string = 'PRODUCTION';
    tauxTva: number = 0;
    isFrench: boolean = false;
    activationId = 0;
    activationIdBackupAndStats = 0;
    activationIdExtendedWarranty = 0;
    scale: number = 0;
    scaleBackupAndStats: number = 0;
    scaleExtendedWarranty: number = 0;
    cu: number = 0;
    selectPayment: number = 1;
    acceptCgs: boolean = false;
    hadLicence: boolean = false;
    hadBackupAndStats: boolean = false;
    hadLicenceExtendedWarranty: boolean = false;
    orderNumber: string = "";
    //language: string = "";
    manuel: boolean = false;

    orderinfo: string = "";
    originalCart: any[] = [];
    products: any[] = [];
    cart: any[] = [];
    bankInfoLacour: bankInfo = {};
    orderAmount = 0;
    orderAmountFL = 0;
    orderAmountTTC = 0;
    payorMail = "";
    payorMailWaranty = "";
    langue: string;
    totalfraisLiv = 0;
    country: string = "";
    checked = false;
    email: string = "";
    prodManuel: boolean = false;
    island: boolean = false;
    cartCode: string = "";
    tvaCkeck: boolean = false;

    displayCGSNav: boolean = false;

    private billingSub: any;
    private tvaSub: any;
    private userSub: any;
    private ribSub: any;
    private modeSub: any;
    private mailSub: any;
    private mailWarantySub: any;
    private langueSub: any;
    private countrySub: any;
    private orderNumberSub: any;
    private adrFactSub: any;
    private emailSub: any;
    private adrLivSub: any;
    private quoteSub: any;
    private billingQuoteSub: any;
    private getBillingSub: any;

    public cgsFR = "assets/CGS-CGU/CGS-FR.pdf";

    AddressForm = new UntypedFormGroup({
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        countryF: new UntypedFormControl('', [Validators.required]),
        checked: new UntypedFormControl(''),
        socialReasonFact: new UntypedFormControl('', [Validators.required]),
        addressFact: new UntypedFormControl('', [Validators.required]),
        postalCodeFact: new UntypedFormControl('', [Validators.required]),
        cityFact: new UntypedFormControl('', [Validators.required]),
        countryFFact: new UntypedFormControl('', [Validators.required]),
        siret: new UntypedFormControl(''),
        tva: new UntypedFormControl(''),
        mail: new UntypedFormControl('', [Validators.required, Validators.email]),
        island: new UntypedFormControl('')
    });

    constructor(private router: Router, private datePipe: DatePipe, private apiService: IxellAPIService, private paymentService: PaymentService, private formBuilder: UntypedFormBuilder,
        private headerService: HeaderService, private errorService: ErrorService, public storage: StorageService, private route: ActivatedRoute) { }


    ngAfterViewInit() {
        if (this.stepper)
            this.stepper._getIndicatorType = () => 'number';
    }

    ngOnInit() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("module panier");

        ///*----------------------------------------------------------------------------------------------------*/console.log("ngOnInit");
        ///*----------------------------------------------------------------------------------------------------*/console.log(JSON.parse(localStorage.getItem("cart")));

        this.cartCode = this.route.snapshot.paramMap.get('cartCode');
        if (this.cartCode) {
            sessionStorage.setItem("cartCode", this.cartCode);
            this.router.navigate(["login"]);
        }
        else {
            let billID = sessionStorage.getItem("cartCode")
            if (billID && billID != "0") {
                this.headerService.verifyRole();
                this.getBillingSub = this.apiService.getBillingByLogin(Number.parseInt(billID)).subscribe(data => {
                    data.lstBillDetails.forEach(details => {
                        let item = {
                            designation: {
                                'fr': details.product.labelP, 'en': details.product.labelENP, 'de': details.product.labelDEP, 'es': details.product.labelESP, 'it': details.product.labelITP,
                                'nl': details.product.labelNLP, 'ro': details.product.labelROP, 'pt': details.product.labelPTP, 'pl': details.product.labelPLP, 'tr': details.product.labelTRP
                            },
                            fraisLiv: {
                                'fr': details.product.fraisLivP, 'en': details.product.fraisLivENP, 'be': details.product.fraisLivBEP, 'de': details.product.fraisLivDEP, 'es': details.product.fraisLivESP, 'it': details.product.fraisLivITP,
                                'nl': details.product.fraisLivNLP, 'ro': details.product.fraisLivROP, 'pt': details.product.fraisLivPTP, 'pl': details.product.fraisLivPLP, 'tr': details.product.fraisLivTRP
                            },
                            fraisLivManuel: details.product.fraisLivManuel,
                            montantFraisLivManuel: details.product.fraisLivManuel ? data.fdpManuel : null,
                            billingID: data.billingID,
                            product: details.product.labelP, qty: details.qty, type: details.product.typeP, qtyMax: details.product.qteStock,
                            amount: details.product.amountP, tPrice: details.product.amountP * details.qty, pId: details.product.productID
                        };
                        this.cart.push(item);
                        localStorage.setItem("cart", JSON.stringify(this.cart));
                        this.headerService.changeNbProduct(this.cart.length);
                        this.headerService.changeProducts(JSON.stringify(this.cart));
                    });
                    this.originalCart = this.cart;
                    this.manageCart();
                },
                    error => {
                        if (this.getBillingSub != null) this.getBillingSub.unsubscribe();
                    }
                );
            }
            else {
                this.manageCart();
            }
        }
    }

    manageCart() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function manageCart");

        var CU = this.storage.get("CU");
        this.langueSub = this.headerService.currentLangue.subscribe(langue => {
            this.langue = langue;
        });
        this.selectPayment = 1;
        this.products = JSON.parse(localStorage.getItem("cart"));

        ///*----------------------------------------------------------------------------------------------------*/console.log("manageCart : products : ", this.products);

        ///*----------------------------------------------------------------------------------------------------*/console.log(this.storage.get("CU"));
        this.countrySub = this.apiService.getCountry(this.storage.get("CU")).subscribe(data => {
            this.country = data;
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);
            ///*----------------------------------------------------------------------------------------------------*/console.log(this.country);
            if (this.products) {
                ///*----------------------------------------------------------------------------------------------------*/console.log("call function totalFraisLiv");
                this.totalFraisLiv(this.country);
                this.products.forEach(element => {
                    if (element.activation) {

                        if (element.product == "Licence IxellColor Connect") {
                            this.activationId = element.activation;
                            this.scale = element.scale;
                            this.hadLicence = true;
                        }

                        if (element.product == "Abonnement Backup & Statistiques") {
                            this.activationIdBackupAndStats = element.activation;
                            this.scaleBackupAndStats = element.scale;
                            this.hadBackupAndStats = true;
                        }

                        if (element.product == "Extension de garantie 2 ans") {
                            this.activationIdExtendedWarranty = element.activation;
                            /*----------------------------------------------------------------------------------------------------*/console.log("activationIdExtendedWarranty = " + element.activation);
                            this.scaleExtendedWarranty = element.scale;
                            this.hadLicenceExtendedWarranty = true;
                        }

                    }
                    if (element.cu)
                        this.cu = element.cu;
                    this.orderAmount += element.tPrice;
                    if (element.type != ProductType.Licence || (element.type == ProductType.Licence && element.product == "Abonnement Backup & Statistiques")) {
                        this.showAddress = true;
                        this.AddressForm.enable();
                    }
                });
                this.orderAmountFL = this.orderAmount + this.totalfraisLiv;
                //this.activateIsland();
            } else {
                this.products = [];
            }
            //désactivation de la validation du formulaire d'addresse si que des licences dans le panier
            if (this.showAddress == false) {
                for (const key in this.AddressForm.controls) {
                    this.AddressForm.get(key).clearValidators();
                    this.AddressForm.get(key).updateValueAndValidity();
                }
            }
            this.mailSub = this.apiService.getPayorMail(this.activationId).subscribe(res => {

                ///*----------------------------------------------------------------------------------------------------*/console.log("mailSub : this.apiService.getPayorMail");
                ///*----------------------------------------------------------------------------------------------------*/console.log(res);

                this.payorMail = res;
                if (this.mailSub != null) this.mailSub.unsubscribe();
                this.modeSub = this.apiService.getCtxMode().subscribe(res => {
                    this.ctxMode = res ? 'TEST' : 'PRODUCTION';
                    if (this.modeSub != null) this.modeSub.unsubscribe();
                    this.tvaSub = this.apiService.getTva(this.activationId, CU).subscribe(res => {
                        ///*----------------------------------------------------------------------------------------------------*/console.log(res);
                        this.tauxTva = res;
                        this.tva = (this.tauxTva * this.orderAmountFL) / 100;
                        this.orderAmountTTC = this.orderAmountFL + this.tva;
                        if (this.tvaSub != null) this.tvaSub.unsubscribe();
                        this.userSub = this.apiService.getCountryPayor(this.activationId, CU).subscribe(res => {
                            this.isFrench = res;
                            if (this.userSub != null) this.userSub.unsubscribe();
                            // Récupére le RIB de lacour
                            this.ribSub = this.apiService.getBankInfo().subscribe(data => {
                                if (data) {
                                    this.bankInfoLacour = data;
                                } else {
                                    this.bankInfoLacour = null;
                                }
                                if (this.ribSub != null) this.ribSub.unsubscribe();
                                this.orderNumberSub = this.apiService.getNumberOrderByLogin().subscribe(data => {
                                    if (data) {
                                        this.orderNumber = "Lacour/" + CU + "/" + data;
                                        if (this.orderNumberSub != null) this.orderNumberSub.unsubscribe();
                                    }
                                    this.recupAdress(this.activationId, CU);
                                }, error => {
                                    this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "GetorderNumber", new Date().toString());
                                    if (this.orderNumberSub != null) this.orderNumberSub.unsubscribe();
                                });
                            }, error => {
                                this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "GetBankInfo", new Date().toString());
                                if (this.ribSub != null) this.ribSub.unsubscribe();
                            });
                        }, error => {
                            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "getCountryCode", new Date().toString());
                            if (this.userSub != null) this.userSub.unsubscribe();
                        });
                    }, error => {
                        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "getTva", new Date().toString());
                        if (this.tvaSub != null) this.tvaSub.unsubscribe();
                    });
                }, error => {
                    this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "getCtxMode", new Date().toString());
                    if (this.modeSub != null) this.modeSub.unsubscribe();
                });
            }, error => {
                if (this.mailSub != null) this.mailSub.unsubscribe();
            });

            this.mailWarantySub = this.apiService.getPayorMail(this.activationIdExtendedWarranty).subscribe(res => {

                /*----------------------------------------------------------------------------------------------------*/console.log("mailWarantySub : this.apiService.getPayorMail");
                /*----------------------------------------------------------------------------------------------------*/console.log(res);

                this.payorMailWaranty = res;
            }, error => {
                if (this.mailWarantySub != null) this.mailWarantySub.unsubscribe();
            });

            this.headerService.changeCanBack(true);
            if (this.countrySub != null) this.countrySub.unsubscribe();
        }, error => {
            if (this.countrySub != null) this.countrySub.unsubscribe();
        });
    }

    ngOnDestroy() {
        if (this.billingSub != null) this.billingSub.unsubscribe();
        if (this.userSub != null) this.userSub.unsubscribe();
        if (this.ribSub != null) this.ribSub.unsubscribe();
        if (this.modeSub != null) this.modeSub.unsubscribe();
        if (this.mailSub != null) this.mailSub.unsubscribe();
        if (this.mailWarantySub != null) this.mailWarantySub.unsubscribe();
        if (this.tvaSub != null) this.tvaSub.unsubscribe();
        if (this.langueSub != null) this.langueSub.unsubscribe();
        if (this.countrySub != null) this.countrySub.unsubscribe();
        if (this.orderNumberSub != null) this.orderNumberSub.unsubscribe();
        if (this.adrFactSub != null) this.adrFactSub.unsubscribe();
        if (this.adrLivSub != null) this.adrLivSub.unsubscribe();
        if (this.emailSub != null) this.emailSub.unsubscribe();
        if (this.quoteSub != null) this.quoteSub.unsubscribe();
        if (this.billingQuoteSub != null) this.billingQuoteSub.unsubscribe();
        if (this.getBillingSub != null) this.getBillingSub.unsubscribe();
    }

    changeQty(product: Product) {
        let ProdI = this.products.findIndex(i => i.pId == product.pId);
        this.products[ProdI].qty = product.qty;
        this.products[ProdI].tPrice = this.products[ProdI].amount * product.qty;
        this.orderAmount = 0;
        this.tva = 0;
        this.orderAmountTTC = 0;
        this.products.forEach(element => {
            this.orderAmount += element.tPrice;
        })
        this.orderAmountFL = this.orderAmount + this.totalfraisLiv;
        this.tva = (this.tauxTva * this.orderAmountFL) / 100;
        this.orderAmountTTC = this.orderAmountFL + this.tva;
        //comparaison avec le panier initiale du devis pour vérifier que les quantités ne soit pas identique
        let change: boolean = false;
        this.originalCart.forEach(elementO => {
            this.products.forEach(element => {
                if (element.pId == elementO.pId) {
                    if (element.qty == elementO.qty) {
                        this.products.forEach(element => { element.montantFraisLivManuel = elementO.montantFraisLivManuel })
                    }
                    else {
                        this.products.forEach(element => { element.montantFraisLivManuel = null })
                        change = true;
                    }
                }
            });
        });
        if (change)
            this.prodManuel = true;
        else
            this.prodManuel = false;

        localStorage.setItem("cart", JSON.stringify(this.products));
        this.headerService.changeProducts(JSON.stringify(this.products));
    }

    removeProduct(name: string) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function removeProduct");

        ///*----------------------------------------------------------------------------------------------------*/console.log(name);
        this.prodManuel = false;
        this.hadLicence = false;
        this.hadBackupAndStats = false;
        this.hadLicenceExtendedWarranty = false;
        let ProdI = this.products.findIndex(i => i.product == name);
        if (ProdI > -1) {
            this.products.splice(ProdI, 1);
        }

        this.activationId = 0;
        this.activationIdBackupAndStats = 0;
        this.activationIdExtendedWarranty = 0;
        this.scale = 0;
        this.scaleBackupAndStats = 0;
        this.scaleExtendedWarranty = 0;

        if (this.products.length > 0) {
            this.totalFraisLiv(this.country);
            this.orderAmount = 0;
            this.orderAmountTTC = 0;
            this.tva = 0;
            this.showAddress = false;
            for (const key in this.AddressForm.controls) {
                this.AddressForm.get(key).clearValidators();
                this.AddressForm.get(key).updateValueAndValidity();
            }

            this.products.forEach(element => {
                if (element.fraisLivManuel) {
                    this.prodManuel = true;
                    this.products.forEach(element => { element.montantFraisLivManuel = null })
                }
                this.orderAmount += element.tPrice;
                if (element.activation) {
                    if (element.product == "Licence IxellColor Connect") {
                        this.activationId = element.activation;
                        this.scale = element.scale;
                        this.hadLicence = true;
                    }

                    if (element.product == "Abonnement Backup & Statistiques") {
                        this.activationIdBackupAndStats = element.activation;
                        this.scaleBackupAndStats = element.scale;
                        this.hadBackupAndStats = true;
                    }

                    if (element.product == "Extension de garantie 2 ans") {
                        this.activationIdExtendedWarranty = element.activation;
                        this.scaleExtendedWarranty = element.scale;
                        this.hadLicenceExtendedWarranty = true;
                    }
                }
                //if (!element.activation) {
                //    this.activationId = 0;
                //}
                //if (element.scale) {
                //    this.scale = element.scale;
                //}
                if (element.cu) {
                    this.cu = element.cu;
                }
                if (element.type != ProductType.Licence || (element.type == ProductType.Licence && element.product == "Abonnement Backup & Statistiques")) {
                    this.showAddress = true;
                    this.AddressForm.enable();
                }
            })
            this.orderAmountFL = this.orderAmount + this.totalfraisLiv;
            this.tva = (this.tauxTva * this.orderAmountFL) / 100;
            this.orderAmountTTC = this.orderAmountFL + this.tva;
        }
        else {
            this.totalfraisLiv = 0;
            this.orderAmount = 0;
            this.orderAmountFL = 0;
            this.orderAmountTTC = 0;
            this.tva = 0;
        }
        localStorage.setItem("cart", JSON.stringify(this.products));
        this.headerService.changeNbProduct(this.products.length);
        this.headerService.changeProducts(JSON.stringify(this.products));
    }

    pay(reglement: number) {

        console.log("function pay");
        if (this.orderAmountTTC > 0) {

            let email: string = this.hadLicenceExtendedWarranty && this.payorMailWaranty ? this.payorMailWaranty : this.activationId > 0 ? this.payorMail : this.AddressForm.value['mail'];
            //Initialisation de la variable qui contiendra la chaine à chiffrer
            //var date = new Date;
            //var dateNow = this.datePipe.transform(date, "yMMddHHmmss");
            var url = window.location.href;
            url = url.replace(this.router.url, "");

            let bill: IBillingV1 = this.getBilling(reglement);

            var params = [
                { name: 'vads_action_mode', value: 'INTERACTIVE' },
                { name: 'vads_amount', value: Math.floor(this.orderAmountTTC * 100) },
                { name: 'vads_available_languages', value: 'fr;en;es;it;de;nl;tr;pl;pt;ro' },
                { name: 'vads_ctx_mode', value: this.ctxMode },
                { name: 'vads_currency', value: '978' },
                { name: 'vads_language', value: this.langue.toString() },
                { name: 'vads_page_action', value: 'PAYMENT' },
                { name: 'vads_payment_cards', value: 'VISA;MASTERCARD' },
                { name: 'vads_payment_config', value: 'SINGLE' },
                { name: 'vads_site_id', value: this.idboutique },
                //{ name: 'vads_trans_date', value: dateNow },
                //{ name: 'vads_url_return', value: url + '/home/paymentAccepted/' + bill.billingID },
                { name: 'vads_version', value: 'V2' },

                { name: 'vads_order_info', value: this.orderinfo },
                { name: 'vads_order_info2', value: this.activationId },
                // { name: 'vads_software', value: 'IXELLWEBLAB' },
                { name: 'vads_order_info3', value: 'IXELLWEBLAB' },
                { name: 'vads_nb_products', value: this.products.length },

                { name: 'vads_cust_email', value: email },
                // { name: 'vads_return_mode', value: 'POST' }

                //{ name: 'vads_cust_id', value: '' },
                //{ name: 'vads_cust_title', value: '' },
                //{ name: 'vads_cust_status', value: '' },
                //{ name: 'vads_cust_first_name', value: '' },
                //{ name: 'vads_cust_last_name', value: '' },
                //{ name: 'vads_cust_legal_name', value: '' },
                //{ name: 'vads_cust_cell_phone', value: '' },
                //{ name: 'vads_cust_phone', value: '' },
                //{ name: 'vads_cust_address_number', value: '' },
                //{ name: 'vads_cust_address', value: '' },
                //{ name: 'vads_cust_district', value: '' },
                //{ name: 'vads_cust_zip', value: '' },
                //{ name: 'vads_cust_city', value: '' },
                //{ name: 'vads_cust_state', value: '' },
                //{ name: 'vads_cust_country', value: '' },

                //{ name: 'vads_ship_to_city', value: '' },
                //{ name: 'vads_ship_to_country', value: '' },
                //{ name: 'vads_ship_to_district', value: '' },
                //{ name: 'vads_ship_to_first_name', value: '' },
                //{ name: 'vads_ship_to_last_name', value: '' },
                //{ name: 'vads_ship_to_legal_name', value: '' },
                //{ name: 'vads_ship_to_phone_num', value: '' },
                //{ name: 'vads_ship_to_state', value: '' },
                //{ name: 'vads_ship_to_status', value: '' },
                //{ name: 'vads_ship_to_street_number', value: '' },
                //{ name: 'vads_ship_to_street', value: '' },
                //{ name: 'vads_ship_to_street2', value: '' },
                //{ name: 'vads_ship_to_zip', value: '' },
            ];

            for (let i in this.products) {
                params.push({ name: 'vads_product_ext_id' + i, value: '' });
                params.push({ name: 'vads_product_label' + i, value: this.products[i]['product'].substring(0, 25) });
                params.push({ name: 'vads_product_amount' + i, value: this.products[i]['amount'] * 100 });
                params.push({ name: 'vads_product_type' + i, value: '' });
                params.push({ name: 'vads_product_ref' + i, value: '' });
                params.push({ name: 'vads_product_qty' + i, value: this.products[i]['qty'] });
            }
            let id: number = 0;
            if (this.manuel)
                id = this.products[0].billingID;
            let payInfo: PaymentInfo = new PaymentInfo();
            payInfo.billing = bill;
            payInfo.payment = reglement;
            payInfo.billingID = id;

            


            //let activationID = this.activationId == 0 ? 0 : this.activationId;

            console.log("savePayment");

            this.billingSub = this.apiService.savePayment(payInfo, this.activationId, this.activationIdBackupAndStats, this.activationIdExtendedWarranty).subscribe(res => {
                params.push({ name: 'vads_order_id', value: res.billingID },
                  { name: 'vads_trans_id', value: this.leftPad(res.billing.transID, 6) },
                  { name: 'vads_url_return', value: url + '/home/paymentAccepted/' + res.billingID },
                  { name: 'vads_trans_date', value: res.billing.transDateUTC }
                );

                if (this.billingSub != null) this.billingSub.unsubscribe();
                if (reglement == 1) {
                  return this.paymentService.getSignaturePostForm(params);
                }
                else {
                  if (reglement > 0)
                    window.print();
                  this.closeVirementPayment();
                  this.router.navigate(['history']);
                  localStorage.clear();
                  this.headerService.changeNbProduct(0);
                  this.headerService.changeProducts("");
                }
                sessionStorage.removeItem("cartCode");
            },
                error => {
                    this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "savePayment", new Date().toString());
                    if (this.billingSub != null) this.billingSub.unsubscribe();
                });
        }
    }

    leftPad(number: number, targetLength: number) {
        var output = number + '';
        while (output.length < targetLength) {
            output = '0' + output;
        }
        return output;
    }

    quantityKeyUp(event: any, product: Product) {
        if (event.charCode >= 48 && event.charCode <= 57)
            return true;
        else
            return false;
    }

    limitQuantity(product: Product, name: string) {
        if (product.qty > product.qtyMax && product.qtyMax != 0)
            product.qty = product.qtyMax;
        this.changeQty(product);
    }

    hideError() {
        let errorcgs = document.getElementById("errorcgs");
        errorcgs.style.display = "none";
    }

    selectPaymentModal() {
        this.AddressForm.markAsTouched();
        if (this.AddressForm.valid) {
            if (this.acceptCgs) {
                if (this.selectPayment == 1) {
                    this.pay(1);
                }
                else if (this.selectPayment == 2) {
                    this.virementPayment();
                }
                else {
                    this.chequePayment();
                }
            }
            else {
                let errorcgs = document.getElementById("errorcgs");
                errorcgs.style.display = "block";
            }
        }
    }


    //initLanguage() {
    //  this.language = this.storage.get("actualLanguage");
    //  if (this.language == null || !this.language) {
    //    this.language = navigator.language.split('-')[0];
    //  }
    //}

    getBilling(reglement: number) {
        let bill: IBillingV1 = new IBillingV1();
        bill.billingInfo = this.orderinfo;
        bill.nbProducts = this.products.length;
        bill.amountTotal = this.orderAmountTTC;
        bill.activationID = this.activationId;
        bill.currency = 978;
        if (reglement == 1) {
            bill.paymentCB = true;
        }
        else {
            bill.paymentCB = false;
        }
        bill.activationID = this.activationId;
        bill.lstBillDetails = [];
        for (let i in this.products) {
            let billDetail: IBillingDetailV1 = new IBillingDetailV1();
            billDetail.productId = this.products[i]['pId'];
            billDetail.qty = parseInt(this.products[i]['qty']);
            //billDetail.product = this.products[i];
            bill.lstBillDetails.push(billDetail);
        }

        console.log(bill.lstBillDetails);

        let adrFact: IAdresseV1 = new IAdresseV1();
        let adrLiv: IAdresseV1 = new IAdresseV1();
        adrFact.socialReason = this.AddressForm.value.socialReasonFact;
        adrFact.address = this.AddressForm.value.addressFact;
        adrFact.postalCode = this.AddressForm.value.postalCodeFact;
        adrFact.city = this.AddressForm.value.cityFact;
        adrFact.country = this.AddressForm.value.countryFFact;
        adrFact.siret = this.AddressForm.value.siret != null ? this.AddressForm.value.siret : "";
        adrFact.tvaIntra = this.AddressForm.value.tva != null ? this.AddressForm.value.tva : "";
        adrFact.type = 1;
        bill.adresseFacturation = adrFact;

        adrLiv.socialReason = this.AddressForm.value.socialReason;
        adrLiv.address = this.AddressForm.value.address;
        adrLiv.postalCode = this.AddressForm.value.postalCode;
        adrLiv.city = this.AddressForm.value.city;
        adrLiv.country = this.AddressForm.value.countryF;
        adrLiv.siret = this.AddressForm.value.siret != null ? this.AddressForm.value.siret : "";
        adrLiv.tvaIntra = this.AddressForm.value.tva != null ? this.AddressForm.value.tva : "";
        adrLiv.type = 2;
        bill.adresseLivraison = adrLiv;

        bill.email = this.AddressForm.value.mail;
        bill.language = this.langue;

        if (this.prodManuel || this.island)
            bill.isQuote = true;
        return bill;
    }

    virementPayment() {
        let modal = document.getElementById("ModalVirement");
        modal.style.display = "block";
    }

    activateIsland() {
        this.island = !this.island;
    }

    closeVirementPayment() {
        let modal = document.getElementById("ModalVirement");
        modal.style.display = "none";
    }

    chequePayment() {
        let modal = document.getElementById("ModalCheque");
        modal.style.display = "block";
    }

    closeChequePayment() {
        let modal = document.getElementById("ModalCheque");
        modal.style.display = "none";
    }

    openCGS() {
        let modal = document.getElementById("ModalCGS");
        modal.style.display = "flex";
    }

    closeCGS() {
        let modal = document.getElementById("ModalCGS");
        modal.style.display = "none";
    }

    closeEmptyCart() {
        if (this.storage.get("scale") != null)
            this.router.navigate(['catalogue']);
        else
            this.router.navigate(['support']);
    }

    totalFraisLiv(country: string) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function totalFraisLiv");
        ///*----------------------------------------------------------------------------------------------------*/console.log(country);
        this.prodManuel = false;
        let fraisLiv = 0;
        this.products.forEach(element => {
            if (element.fraisLivManuel) {
                this.prodManuel = true;
                if (sessionStorage.getItem("cartCode") != null) {
                    if (element.montantFraisLivManuel > 0) {
                        fraisLiv = element.montantFraisLivManuel;
                        this.prodManuel = false;
                    }
                }
            }
            else {
                switch (country.toLowerCase()) {
                    case "be":
                    case "belgium":
                        if (fraisLiv < element.fraisLiv.be)
                            fraisLiv = element.fraisLiv.be;
                        break;
                    case "en":
                    case "gb":
                    case "united kingdom":
                        if (fraisLiv < element.fraisLiv.en)
                            fraisLiv = element.fraisLiv.en;
                    case "de":
                    case "germany":
                        if (fraisLiv < element.fraisLiv.de)
                            fraisLiv = element.fraisLiv.de;
                        break;
                    case "es":
                    case "spain":
                        if (fraisLiv < element.fraisLiv.es)
                            fraisLiv = element.fraisLiv.es;
                        break;
                    case "it":
                    case "italy":
                        if (fraisLiv < element.fraisLiv.it)
                            fraisLiv = element.fraisLiv.it;
                        break;
                    case "nl":
                    case "netherlands":
                        if (fraisLiv < element.fraisLiv.nl)
                            fraisLiv = element.fraisLiv.nl;
                        break;
                    case "pl":
                    case "poland":
                        if (fraisLiv < element.fraisLiv.pl)
                            fraisLiv = element.fraisLiv.pl;
                        break;
                    case "pt":
                    case "portugal":
                        if (fraisLiv < element.fraisLiv.pt)
                            fraisLiv = element.fraisLiv.pt;
                        break;
                    case "ro":
                    case "romania":
                        if (fraisLiv < element.fraisLiv.ro)
                            fraisLiv = element.fraisLiv.ro;
                        break;
                    case "tr":
                    case "turkey":
                        if (fraisLiv < element.fraisLiv.tr)
                            fraisLiv = element.fraisLiv.tr;
                        break;
                    case "fr":
                    case "france":
                        if (fraisLiv < element.fraisLiv.fr)
                            fraisLiv = element.fraisLiv.fr;
                        break;
                    default:
                        if (fraisLiv < 0)
                            fraisLiv = 0;
                        break;
                }
            }
            this.totalfraisLiv = fraisLiv;
        })

    }

    recupEmail() {
        this.emailSub = this.apiService.getEmailCommandByLogin().subscribe(data => {
            this.email = data;
            this.AddressForm.setValue({
                socialReason: this.AddressForm.value.socialReason,
                address: this.AddressForm.value.address,
                postalCode: this.AddressForm.value.postalCode,
                city: this.AddressForm.value.city,
                countryF: this.AddressForm.value.countryF,
                checked: this.AddressForm.value.checked,
                socialReasonFact: this.AddressForm.value.socialReasonFact,
                addressFact: this.AddressForm.value.addressFact,
                postalCodeFact: this.AddressForm.value.postalCodeFact,
                cityFact: this.AddressForm.value.cityFact,
                countryFFact: this.AddressForm.value.countryFFact,
                siret: this.AddressForm.value.siret,
                tva: this.AddressForm.value.tva,
                mail: data,
                island: this.AddressForm.value.island
            });
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "RecupEmail", new Date().toString());
            if (this.emailSub != null) this.emailSub.unsubscribe();
        });
    }

    recupAdress(activationId: number, CU: string) {
        this.adrFactSub = this.apiService.getAddressFact(activationId, CU).subscribe(adrFacturation => {
            this.AddressForm.setValue({
                socialReason: this.AddressForm.value.socialReason,
                address: this.AddressForm.value.address,
                postalCode: this.AddressForm.value.postalCode,
                city: this.AddressForm.value.city,
                countryF: this.AddressForm.value.countryF,
                checked: this.AddressForm.value.checked,
                socialReasonFact: adrFacturation.socialReason,
                addressFact: adrFacturation.address,
                postalCodeFact: adrFacturation.postalCode,
                cityFact: adrFacturation.city,
                countryFFact: adrFacturation.country,
                siret: adrFacturation.siret,
                tva: adrFacturation.tva,
                mail: this.AddressForm.value.mail,
                island: false
            });

            this.adrLivSub = this.apiService.getAddressDeli(activationId, CU).subscribe(adrLivraison => {
                this.AddressForm.setValue({
                    socialReason: adrLivraison.socialReason,
                    address: adrLivraison.address,
                    postalCode: adrLivraison.postalCode,
                    city: adrLivraison.city,
                    countryF: adrLivraison.country,
                    checked: this.AddressForm.value.checked,
                    socialReasonFact: this.AddressForm.value.socialReasonFact,
                    addressFact: this.AddressForm.value.addressFact,
                    postalCodeFact: this.AddressForm.value.postalCodeFact,
                    cityFact: this.AddressForm.value.cityFact,
                    countryFFact: this.AddressForm.value.countryFFact,
                    siret: this.AddressForm.value.siret,
                    tva: this.AddressForm.value.tva,
                    mail: this.AddressForm.value.mail,
                    island: false
                });

                this.manageCountryDelivery();
                this.recupEmail();
                if (this.adrLivSub != null) this.adrLivSub.unsubscribe();
            }, error => {
                this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "RecupAdresseLivraison", new Date().toString());
                if (this.adrLivSub != null) this.adrLivSub.unsubscribe();
            });

            this.changeCountryFacturation();
            if (this.adrFactSub != null) this.adrFactSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "RecupAdresseFacturation", new Date().toString());
            if (this.adrFactSub != null) this.adrFactSub.unsubscribe();
        });
    }

    changeCountryDelivery() {
        this.products.forEach(element => { element.montantFraisLivManuel = null })
        this.manageCountryDelivery();
    }

    manageCountryDelivery() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function manageCountryDelivery");

        this.orderAmountFL -= this.totalfraisLiv;
        this.tva = 0;
        let countryLiv: string = this.AddressForm.value["countryF"];
        if (!countryLiv) {
            countryLiv = "France";
        }
        this.totalFraisLiv(countryLiv);
        this.orderAmountFL = this.orderAmount + this.totalfraisLiv;
        this.tva = (this.tauxTva * this.orderAmountFL) / 100;
        this.orderAmountTTC = this.orderAmountFL + this.tva;
        //this.prodManuel = false;
        this.AddressForm.setValue({
            socialReason: this.AddressForm.value.socialReason,
            address: this.AddressForm.value.address,
            postalCode: this.AddressForm.value.postalCode,
            city: this.AddressForm.value.city,
            countryF: this.AddressForm.value.countryF,
            checked: this.AddressForm.value.checked,
            socialReasonFact: this.AddressForm.value.socialReasonFact,
            addressFact: this.AddressForm.value.addressFact,
            postalCodeFact: this.AddressForm.value.postalCodeFact,
            cityFact: this.AddressForm.value.cityFact,
            countryFFact: this.AddressForm.value.countryFFact,
            siret: this.AddressForm.value.siret,
            tva: this.AddressForm.value.tva,
            mail: this.AddressForm.value.mail,
            island: false
        });
    }

    //changeCountryFacturation() {
    //  if (this.AddressForm.value.countryFFact) {
    //    if (this.showAddress == true)
    //      this.AddressForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name == this.AddressForm.value.countryFFact).tvaRegEx)]);
    //    this.AddressForm.controls['tva'].updateValueAndValidity();
    //  }

    //  let countryFact: string = this.AddressForm.value["countryFFact"];
    //  if (countryFact && countryFact.toLowerCase() == "france") {
    //    this.isFrench = true;
    //    this.tauxTva = 20;
    //  }
    //  else {
    //    this.isFrench = false;
    //    //if (countryFact != null) {
    //    //  if (countryFact.toLowerCase() != "turkey" && !this.AddressForm.value.tva)
    //    //    this.tauxTva = 20;
    //    //  else
    //      this.tauxTva = 0;
    //    //}
    //  }
    //  this.tva = (this.tauxTva * this.orderAmountFL) / 100;
    //  this.orderAmountTTC = this.orderAmountFL + this.tva;
    //}

    //checkTvaIntra() {
    //  this.changeCountryFacturation()
    //}


    changeCountryFacturation() {
        if (this.AddressForm.value.countryFFact && this.showAddress) {

            var tvaRegEx = Constants.countries.find(c => c.name == this.AddressForm.value.countryFFact).tvaRegEx;
            if (tvaRegEx != "") {
                this.AddressForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.AddressForm.value.countryFFact.toLowerCase()).tvaRegEx)]);
                this.AddressForm.controls['tva'].updateValueAndValidity();
                this.tvaCkeck = true;
            } else {
                this.AddressForm.controls['tva'].clearValidators();
                this.AddressForm.controls['tva'].updateValueAndValidity();
                if (this.AddressForm.value.tva != "") {
                    this.AddressForm.controls["tva"].setValue("");
                }
                this.tvaCkeck = false;
            }

        }
        else if (!this.showAddress) {
            this.AddressForm.controls['tva'].clearValidators();
            this.AddressForm.controls['tva'].updateValueAndValidity();
            if (this.AddressForm.value.tva != "") {
                this.AddressForm.controls["tva"].setValue("");
            }
            this.tvaCkeck = false;
        }

        //let countryFact: string = this.companyForm.value["country"];
        //if (countryFact && countryFact.toLowerCase() == "france") {
        //  this.isFrench = true;
        //  this.tauxTva = 20;
        //}
        //else {
        //  this.isFrench = false;
        //  this.tauxTva = 0;
        //}
        ////this.tva = (this.tauxTva * this.orderAmountFL) / 100;
        ////this.orderAmountTTC = this.orderAmountFL + this.tva;
    }

    checkTvaIntra() { // Si changement, mettre également à jour adminlacourLicence
        //this.changeCountryFacturation()
        let countryFact: string = this.AddressForm.value["countryFFact"];
        if (countryFact && countryFact.toLowerCase() == "france") {
            this.isFrench = true;
            this.tauxTva = 20;
        }
        else {
            this.isFrench = false;
            this.tauxTva = 0;
        }
        this.tva = (this.tauxTva * this.orderAmountFL) / 100
        this.orderAmountTTC = this.orderAmountFL + this.tva;
    }

    updateCountry() {
        this.changeCountryFacturation();
    }

    copyFacturationData() {
        if (this.checked == false) {
            this.AddressForm.setValue({
                socialReason: this.AddressForm.value.socialReasonFact,
                address: this.AddressForm.value.addressFact,
                postalCode: this.AddressForm.value.postalCodeFact,
                city: this.AddressForm.value.cityFact,
                countryF: this.AddressForm.value.countryFFact,
                socialReasonFact: this.AddressForm.value.socialReasonFact,
                addressFact: this.AddressForm.value.addressFact,
                postalCodeFact: this.AddressForm.value.postalCodeFact,
                cityFact: this.AddressForm.value.cityFact,
                countryFFact: this.AddressForm.value.countryFFact,
                siret: this.AddressForm.value.siret,
                tva: this.AddressForm.value.tva,
                mail: this.AddressForm.value.mail,
                checked: false,
                island: this.AddressForm.value.island != "" ? this.AddressForm.value.island : false
            });
            this.checked = true;
        } else if (this.checked) {
            this.AddressForm.setValue({
                socialReason: '',
                address: '',
                postalCode: '',
                city: '',
                countryF: '',
                socialReasonFact: this.AddressForm.value.socialReasonFact,
                addressFact: this.AddressForm.value.addressFact,
                postalCodeFact: this.AddressForm.value.postalCodeFact,
                cityFact: this.AddressForm.value.cityFact,
                countryFFact: this.AddressForm.value.countryFFact,
                siret: this.AddressForm.value.siret,
                tva: this.AddressForm.value.tva,
                mail: this.AddressForm.value.mail,
                checked: true,
                island: false
            });
            this.checked = false;
        }
        this.manageCountryDelivery();
    }

    changePostalCode() {
        let CPLiv: string = this.AddressForm.value.postalCode;
        if (this.AddressForm.value.countryF && CPLiv && this.AddressForm.value.countryF.toLowerCase() == "france" && CPLiv.length == 5 && (CPLiv.substr(0, 2) == "2A" || CPLiv.substr(0, 2) == "2B" || CPLiv.substr(0, 2) == "20")) {
            this.totalfraisLiv += 20;
            this.orderAmountFL = this.orderAmount + this.totalfraisLiv;
            this.tva = (this.tauxTva * this.orderAmountFL) / 100;
            this.orderAmountTTC = this.orderAmountFL + this.tva;
        }
    }

    /* CGS */

    cgsModal() {
        this.openCGS();
        this.onCGSLoad();
        window.setTimeout(() => { this.onCGSLoad(); }, 50);
    }

    _findTreeSection(element: any) {
        var _el: any = [];
        if (!element) return _el;
        var _children = element.children;
        if (_children == undefined) return _el;
        _children = _children[0].children;
        if (_children == undefined) return _el;
        for (var i = 0; i < element.children.length; i++) {
            var _elem = element.children[i];
            if (_elem.tagName.toLowerCase() == "section") {
                var _anchor = _elem.children.item(0);
                var _title = _elem.children.item(1);
                var _content = _elem.children.item(2);
                if (!_anchor || _anchor.tagName.toLowerCase() != "a") break;
                _el.push({
                    anchorNode: _anchor,
                    titleNode: _title,
                    contentNode: _content,
                    link: _anchor.name,
                    text: _title.innerText,
                    children: this._findTreeSection(_content)
                })
            }

        }
        return _el;
    }

    toggleCGSNav() {
        this.displayCGSNav = !this.displayCGSNav;
    }

    cgsLangChange() {
        setTimeout(() => this.onCGSLoad(), 50);
    }

    _createSectionMenu(elements: any) {
        if (!elements || elements.length == 0) return undefined;
        let _ul = document.createElement("ul");
        for (let i = 0; i < elements.length; i++) {
            let _element = elements[i];

            let _li = document.createElement("li");

            let _a = document.createElement("a");
            _a.innerText = _element.text;
            _a.style.cursor = 'pointer';
            _a.addEventListener('click', () => {
                document.querySelector(`a[name="${_element.link}"`)?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                this.toggleCGSNav();
            });

            let _childUl = this._createSectionMenu(_element.children);

            _li.appendChild(_a);
            if (_childUl) _li.appendChild(_childUl);
            _ul.appendChild(_li);
        }
        return _ul;
    }

    onCGSLoad() {
        // menu
        var _cgs = document.querySelectorAll(".cgs").item(0);
        var _cgsBody = document.querySelectorAll(".cgs-body").item(0);
        var _cgsMenu = document.querySelectorAll(".cgs-menu").item(0);
        var _cgsMenuSections = document.getElementById("cgs-menu-sections");
        if (!_cgs || !_cgsBody || !_cgsMenu || !_cgsMenuSections) return;

        // récupération des sections
        var _treeSections = this._findTreeSection(_cgsBody);
        // création du menu
        var _ulTree = this._createSectionMenu(_treeSections);
        // ajout dans le DOM
        while (_cgsMenuSections.firstChild) {
            _cgsMenuSections.removeChild(_cgsMenuSections.firstChild);
        }
        _cgsMenuSections.appendChild(_ulTree);
    }
}

export class Country {
    name: string;
    txt: string;
    tvaRegEx: string;
}
